import React, { useState } from 'react';
import { BsFillArrowDownCircleFill, BsFillArrowUpCircleFill } from 'react-icons/bs';
import { CurrentTeamMatchAway } from '../edit-team-members/CurrentTeamMatchAway';
import { SubstitudesMatchAway } from '../edit-team-members/SubstitudesMatchAway';
import { useSelector } from 'react-redux';
import { selectMatchData } from '../../../slices/matchSlice';
import { MatchStatus } from '../../../utils/constants';
import { getOgmasFromTeam } from '../../../utils/utils';
import { MatchMemberRowAway } from './match-member-row-away';
export function AwayTeamInfo({ canEdit }: { canEdit: boolean }) {
  const btnListAway = [
    {
      title: 'Edit',
      onClick: () => setEditModeAway(true),
      edit: false,
    },
    {
      title: 'Cancel',
      onClick: () => setEditModeAway(false),
      edit: true,
    },
  ];
  const matchData = useSelector(selectMatchData);
  const ogmas = getOgmasFromTeam(matchData.away_team?.[0]);
  const checkedInawayTeam = matchData.away_team_active.filter((u: any) =>
    matchData.checked_in_students.includes(u),
  ).length;

  const [showAvailableAway, setShowAvailableAway] = useState(false);
  const [editModeAway, setEditModeAway] = useState(false);
  return (
    <div className='flex gap-2 flex-col w-fit'>
      <h2 className='text-center'>Current Roster</h2>
      <h5 className='text-sm self-end'>{`${checkedInawayTeam}/${matchData.Game.active_limit} Checked In`}</h5>
      <CurrentTeamMatchAway editMode={editModeAway} />
      <h1>General Manager(s)</h1>
      {ogmas.length > 0 &&
        ogmas?.map((u: any, i: any) => (
          <div className='w-full'>
            <MatchMemberRowAway
              editMode={false}
              gameId={matchData.home_team?.[0]?.game_id}
              InGameName={
                u?.InGameName?.filter(
                  (name: any) => name.game_id === matchData.home_team?.[0]?.game_id,
                ) ?? ''
              }
              activeMember
              key={i}
              id={u?.id}
              {...(u ?? {})}
              isCaptain={Number(u?.id) === matchData.home_team?.[0]?.captain}
              isItHome={true}
              isCheckedIn={matchData.checked_in_students.includes(u?.id)}
              studentId={u?.id ?? null}
              gameName={matchData?.Game?.name}
            />
          </div>
        ))}
    </div>
  );
}
